import { EventBroker } from "@/frontend/lib/utils/event-broker";

export const EDIT_IMAGE_EVENTS = {
  INIT: 'INIT',
  SAVED: 'SAVED'
}

export const editImageEventBroker = new EventBroker();
